//requires: public\EnhancedContent.js
/**
 * 
 */


L.EnhancedContent.External = L.EnhancedContent.extend({

	statics: {
		TYPE: "external"
	},

	options: {
		blankPage: true
	},
	
	getType: function(){
		return  L.EnhancedContent.External.TYPE;
	},	

	setExternalLink: function(link){
		this._externalLink=link;
	},
	
	getExternalLink: function(){
		return this._externalLink;
	},
	
	display: function(){
		
		if (this.getExternalLink){
			if (this.options.blankPage){
				window.open(this.getExternalLink(),'_blank');
			}else{
				window.location.href = this.getExternalLink();
			}
		}else{
			void 0;
		}
	},
	
	toJSONable: function(){
		var jsonable= {};
		
		jsonable['type'] = this.getType();
		jsonable['externalLink'] = this.getExternalLink();
		jsonable['blankPage'] = this.options.blankPage;
		return jsonable;
	}
	
	
})


L.EnhancedContent.external = function (externalLink, options) {
    return new L.EnhancedContent.External(externalLink, options);
};